module.exports = __webpack_public_path__ + "img/icon_tongbupai@2x.ee69e5f0.png";